<template>
  <div v-if="typeOt">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('detailTypeOt.title',
                { libelle: typeOt.libelle }) }}</h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button
              class="button"
              @click="checkPermissions(constantes.TYPE_OT.lecture)
                     ? $router.push({name: 'l.logistique.type_ot'})
                     : showPopUp()">
              {{ $t('general.button.return') }}
            </button>
            <button
              class="button is-addOrEdit"
              :class="{ 'button-access-no-permission' : !checkPermissions(constantes.TYPE_OT.maj) }"
              @click="checkPermissions(constantes.TYPE_OT.maj)
                     ? $router.push({name: 'm.logistique.type_ot-edit', params: { id: typeOt.id }})
                     : showPopUp()">
              {{ $t('general.button.edit') }}
              <b-dropdown class="mgl-10px has-text-left" position="is-bottom-left"
                          @click.native.prevent.stop>
                <div slot="trigger">
                  <b-icon icon="chevron-down"></b-icon>
                </div>
                <b-dropdown-item
                  :class="{ 'button-access-no-permission' :
             !checkPermissions(constantes.TYPE_OT.supprimer) }"
                  @click.native.prevent.stop="checkPermissions(constantes.TYPE_OT.supprimer)
                   ? popUpSuppression = true : showPopUp()">
                  {{ $t('general.button.delete') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <div class="card">
        <header class="header-card">
          <p>{{ $t('detailTypeOt.informations.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('detailTypeOt.informations.type')"
                      custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{ typeOt.libelle }}
                </span>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('detailTypeOt.informations.actionIntervention')"
                      custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{ getActionIntervention }}
                </span>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('detailTypeOt.informations.produit')"
                      custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{ getProduitReference }}
                </span>
              </b-field>
            </div>
            <div class="column is-4" v-if="moduleImpressionActive">
              <b-field :label="$t('detailTypeOt.informations.isVisibleInSuiviProduction')"
                      custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{ typeOt.isVisibleInSuiviProduction ? $t('general.oui') : $t('general.non') }}
                </span>
              </b-field>
            </div>
            <div class="column is-4" v-if="moduleImpressionActive">
              <b-field :label="$t('detailTypeOt.informations.couleur')"
                      custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold" v-if="typeOt.couleur">
                  <div :style="typeOtColorStyle" class="width-height-25">
                    &nbsp;
                  </div>
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <addEditViewTaches
        :typeOt="typeOt"
        is-detail
      />
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :messHeader="$t('detailTypeOt.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteTypeOt"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { TYPE_OT } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  LISTE_ACTION_INTERVENTION,
  LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE,
  LISTE_ACTION_INTERVENTION_DISPOSITF,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/logistique/typeOt';
import addEditViewTaches from '@/components/logistique/typeOt/addEdit/addEditViewTaches';
import popUpPrevention from '@/components/general/popUpPrevention';
import { deleteTypeOt } from '@/api/typeOt';
import messageSucces from '@/services/general/messageSucces';
import { validationSuppression } from '@/services/logistique/typeOt/validation';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    breadcrumb,
    addEditViewTaches,
    popUpPrevention,
  },
  data() {
    return {
      typeOt: null,
      constantes: {
        TYPE_OT,
      },
      popUpSuppression: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
    };
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
      loadParametresInterne: 'loadParametresInterne',
    }),
    async deleteTypeOt() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        this.errorPopUp = false;
        await deleteTypeOt(this.typeOt.id);
        messageSucces(this.$t('listeTypeOt.messages.success.typeOtDelete'));
        this.popUpSuppression = false;
        await this.loadParametreForce(PARAMETRES_KEYS.typeOt);
        loadingComponent.close();
        await this.$router.push({ name: 'l.logistique.type_ot' });
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$i18n.t('detailTypeOt.breadcrumb.typeOt'), route: { name: 'l.logistique.type_ot' }, isActive: false },
        { title: this.$i18n.t('detailTypeOt.breadcrumb.detailTypeOt'), route: '', isActive: true },
      ];
      return output;
    },
    getActionIntervention() {
      let interventionsActions = LISTE_ACTION_INTERVENTION;
      if (this.moduleStockTiersActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE);
      }
      if (this.moduleEmplacementClientActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_DISPOSITF);
      }
      const actionFind = interventionsActions.find((action) => {
        return action.code === this.typeOt.actionInterventionOt;
      });
      return actionFind ? this.$i18n.t(actionFind.libelle) : '';
    },
    getProduitReference() {
      return this.typeOt.produit ? this.typeOt.produit.reference : '';
    },
    typeOtColorStyle() {
      return ({
        'background-color': this.typeOt.couleur,
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.typeOt = (await get(this.$route.params.id)).data.result;
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.typeOt.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
